export const sortByValue = (arr, objectStringValue, direction) => {
    return direction === 'asc' ?
        [...arr.sort((a, b) => {
            return (a[objectStringValue] === "") - (b[objectStringValue] === "") ||
                String(a[objectStringValue]).localeCompare(String(b[objectStringValue]))
        })]
        :
        [...arr.sort((a, b) => {
           return (a[objectStringValue] === "") - (b[objectStringValue] === "") ||
               String(b[objectStringValue]).localeCompare(String(a[objectStringValue]))
        })]
};

export const sortByNumericalValue = (arr, numValue, direction) => {
    return direction === 'asc' ?
        [...arr.sort((a, b) => a[numValue] - b[numValue])]
        :
        [...arr.sort((a, b) => b[numValue]  - a[numValue])]
};